module.exports = __webpack_public_path__ + "static/media/albero.7ecf5776.png";